export enum LeagueName {
    Competition = 'Competition',
    Cup = 'Cup',
    SuperCup = 'SuperCup',
    WorldCup = "WorldCup"
}